import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage.js';
import HomePage from './HomePage.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState, useEffect } from 'react';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    return !!personalDetails?.LoginToken;
  });

  const checkAuthentication = () => {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    setIsAuthenticated(!!personalDetails?.LoginToken);
  };

  useEffect(() => {
    checkAuthentication(); // Run on initial load

    const handleStorageChange = () => {
      checkAuthentication();
    };

    window.addEventListener("storage", handleStorageChange);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage onLoginSuccess={checkAuthentication} />} />
        <Route path="/home" element={isAuthenticated ? <HomePage /> : <Navigate to="/" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
